export default {
	emailAddress: "",
	password: "",
	isValid: false,
	errorMessage: "",
	rememberMe: false,
};
